import React, {FC} from 'react';

import {LinkButton, ILinkButtonProps} from '../link-button';

interface IButtonsBarProps {
    buttons?: ILinkButtonProps[];
}
export const ButtonsBar: FC<IButtonsBarProps> = ({buttons}: IButtonsBarProps) => (
    <>
        {buttons?.map(btn => (
            <LinkButton
                key={`${btn.title}_${btn.link}_${btn.type}`}
                type={btn.type}
                title={btn.title}
                link={btn.link}
            />
        ))}
    </>
);
